var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGooglePay(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.052,
    height: 16.02,
    viewBox: "0 0 19.052 16.02",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "google-pay-logo-2020",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_69847",
    "data-name": "Path 69847",
    d: "M123.227,31.5c-1.281-.259-3.346-.61-3.923.6-1.763,3.054-2.776,6.251-3.538,7.622.08.046,3.592,2.084,3.841,2.2a2.106,2.106,0,0,0,2.669-.8c1.558-2.81,1.162-2.078,2.817-4.945A3.338,3.338,0,0,0,123.227,31.5Z",
    transform: "translate(-106.426 -28.723)",
    fill: "#ea4335"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69848",
    "data-name": "Path 69848",
    d: "M58.667,45.5c-.86-.984-1.491-2.952-.735-4.055,2.208-3.824,3.975-6.139,5.365-8.459.737.426,3.69,2.1,3.887,2.273a2.154,2.154,0,0,1,.61,2.677c-1.654,2.754-2.333,4-4.015,6.913A3.461,3.461,0,0,1,58.667,45.5Z",
    transform: "translate(-52.947 -30.327)",
    fill: "#fdbd00"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_52471",
    "data-name": "Group 52471",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_69849",
    "data-name": "Path 69849",
    d: "M54.578.827A4.463,4.463,0,0,0,51.048.1,4.359,4.359,0,0,0,48.59,1.709c-1.209,1.981-2.355,3.941-3.839,6.6a1.967,1.967,0,0,0,.3,2.222,24.335,24.335,0,0,0,2.777,1.6,1.8,1.8,0,0,0,1.867-.439c.137-.141,3.275-5.531,4.159-7.12A3.36,3.36,0,0,1,58.333,3s-2.8-1.626-3.755-2.173Z",
    transform: "translate(-40.94 0)",
    fill: "#2da94f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69850",
    "data-name": "Path 69850",
    d: "M2.568,39.53A4.463,4.463,0,0,1,.175,36.835,4.36,4.36,0,0,1,.338,33.9c1.111-2.038,1.1-2.048,2.662-4.662a1.967,1.967,0,0,1,2.077-.848A24.328,24.328,0,0,1,7.848,30,1.8,1.8,0,0,1,8.4,31.837c-.054.189-2.02,3.64-2.954,5.2a3.359,3.359,0,0,0,.88,4.658s-2.81-1.616-3.759-2.165Z",
    transform: "translate(0 -26.054)",
    fill: "#297aec"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePay);
export default __webpack_public_path__ + "static/media/google-pay.527a31466646e265647639bb1cbf9700.svg";
export { ForwardRef as ReactComponent };